export default "__VITE_ASSET__JzJHZtgs__"